<template>
  <div>
      <div id="page" data-swup="0">
        <div class="page-content pb-0">
          <div class="card bg-transparent mb-0">
            <div class="row">
              <div class="col-6 zurag">
                <img :src="`${myResBaseUrl}ubtz/3.png`" class="zurag" alt="logo" />
              </div>
              <div class="col-6 zurag">
                <img :src="`${myResBaseUrl}ubtz/youthubtz.png`" class="zurag" />
              </div>
            </div>
            <div class="mx-3 text-center">
              <h1 class="font-700 fa-2x color-white text-shadow-l">
                "УБТЗ" ХНН-ийн ЗАЛУУЧУУДЫН<br />
                ТӨВ БАЙГУУЛЛАГА
              </h1>
              <div class="col-12"></div>
              <div class="row mb-0 mx-auto">
                <template v-for="page in getMenuList(0)" >
                  <div class="col-4" :key="page.id">
                    <a @click="loadPage(page)"
                      :class="`icon text-shadow-l icon-xxl rounded-xl ${getColorClass(page.f1)}`"
                      ><i :class="`${getClass(page.f1)} text-shadow-l font-30`" style="color: #5a6087"></i
                    ></a>
                    <p @click="loadPage(page)" class="text-shadow-l pt-1 mb-3 color-white font-12 lh-sm">
                      {{page.task}}
                    </p>
                  </div>
                </template>
              </div>
              <div class="col-12">
                <button @click="logout()" class="btn btn-warning">Гарах</button>
              </div>
            </div>
          </div>
          <div>
            <div class="card card-style">
              <h1 class="text-center text-uppercase font-800 pt-4 font-30">
                UBTZ Youth
              </h1>
              <p class="boxed-text-xl">
                210535 Улаанбаатар хот, Баянгол дүүрэг, Сөүлийн гудамж-42,
                Ulaanbaatar, Mongolia
              </p>
              <p class="text-center">
                <a target="_blank"
                  href="http://www.youthubtz.mn"
                  class="default-link icon icon-m shadow-xl rounded-sm mx-1 color-white bg-webpage"
                  ><i class="fa fa-globe"></i
                ></a>
                <a target="_blank"
                  href="https://www.facebook.com/youth.UBrailway"
                  class="default-link icon icon-m shadow-xl rounded-sm mx-1 color-white bg-facebook"
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a target="_blank"
                  href="https://www.youtube.com/@youthubtz7633/featured"
                  class="default-link icon icon-m shadow-xl rounded-sm mx-1 color-white bg-youtube"
                  ><i class="fab fa-youtube"></i
                ></a>
                <a
                  href="mailto:youth.ubtz@gmail.com"
                  class="default-link icon icon-m shadow-xl rounded-sm mx-1 color-white bg-mailbox"
                  ><i class="fa fa-at"></i
                ></a>
                <a
                  href="tel:88012330"
                  class="default-link icon icon-m shadow-xl rounded-sm mx-1 color-white bg-phone"
                  ><i class="fa fa-phone"></i
                ></a>
              </p>
              <div class="divider divider-margins mb-3"></div>
              <p class="font-11 text-center mb-0 pb-3">
                Copyright © <span class="copyright-year">2023</span>. All
                rights reserved.
              </p>
            </div>
          </div>
        </div>
    
        <div class="page-bg">
          <div></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  
  import { Notification } from "element-ui";
  import "element-ui/lib/theme-chalk/index.css";

  export default {
    data(){
      return{
        myResBaseUrl: "https://res.gosmart.mn/"
      }
    },
    created() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    mounted(){
    },
    methods: {
      ...mapActions(["handleMainMenu", "handleDetailModal", "handleLoading", "handleLogOut", "handleDynamicMenuLoaded"]),
      logout(){
        //Notification.info({ title: "step-1" });
        this.handleLoading({ isLoading: true });
        //Notification.info({ title: "step-2" });
        this.handleLogOut({ store: this.$store }).then((res) => {
          //Notification.info({ title: "step1" });
          if (res != false) {
            //Notification.info({ title: "step2" });
            this.handleDynamicMenuLoaded(false);
            //Notification.info({ title: "step3" });
            this.handleLoading({ isLoading: false });
            //Notification.info({ title: "step4" });
            this.$router.push({ name: "login" });
            //Notification.info({ title: "step5" });
          }
        });
      },
      getColorClass(cls){
          const myArray = cls.split(" ");
          return myArray[2];
      },
      getClass(cls){
          const myArray = cls.split(" ");
          return myArray[0] +" "+ myArray[1];
      },
      getMenuList(parentId) {
        return _.sortBy(
          this.$store.state.app.pages.filter(
            (x) => x.parentId == parentId && x.i2 == 1
          ),
          "ord",
          "asc"
        );
      },
      loadPage(task) {
        //this.hideMainMenu();
        this.activeMenuId = task.id;
        console.log(task.locTypeId);
        if (task.locTypeId == 39973) {
          //шууд агуулга
          //task.organizationTaskId
          this.handleDetailModal({ show: true, id: task.organizationTaskId });
        } else if (task.locTypeId == 39972) {
          this.$router.push({ name: "webList", params: { id: task.locTypeId1 } });
        } else if (task.locTypeId == 39971) {
          //engiin
          //alert(task.locTypeId1)
          this.$router.push({
            name: task.taskEn,
            params: { id: task.locTypeId1 },
          });
        }else if(task.locTypeId == 39974){
          //alert('Тун удахгүй');
          Notification.info({ title: "тун удахгүй" });
        }
      },
    },
  };
  </script>
  